import { SELECT_DATE } from "../actions/types";

export default (date = "", action) => {
  if (action.type === SELECT_DATE) {
    return action.payload;
  }
  return date;
};
